/* Geo Lanes, Galerie auf der Produktseite (17.08.2026)
   ------------------------------------------------------------------
   Problem: die kleinen Bilder unter dem Hauptbild reagierten
   unzuverlaessig. Mal genuegte ein Klick, mal brauchte es zwei, ohne
   erkennbares Muster und bei jedem beliebigen Bild.

   Ursache: das Karussell des Themes wertet die Maus selbst aus und
   entscheidet erst beim Loslassen, ob das ein Klick oder ein Ziehen
   war. Bewegt sich der Zeiger zwischen Druecken und Loslassen auch
   nur ein bis zwei Pixel, gilt das als Ziehen und der Klick wird
   verworfen. Deshalb wirkte es zufaellig.

   Nachgewiesen: ein sauber erzeugter Klick auf ein kleines Bild
   bewegt die Galerie gar nicht, das Bauteil hoert also nicht auf
   den Klick selbst, sondern auf die Zeigerfolge davor.

   Loesung: wir werten die Zeigerfolge selbst aus. Bleibt der Zeiger
   zwischen Druecken und Loslassen innerhalb von 8 Pixeln, ist es ein
   Klick, und wir schalten die Galerie ueber die eigene Schnittstelle
   des Themes weiter, window.xoCarousel.goTo(name, index). Bewegt er
   sich weiter, lassen wir alles unberuehrt, damit das Wischen auf
   dem Telefon weiter funktioniert.

   Am Bauteil selbst wird nichts geaendert. Faellt die Schnittstelle
   weg, passiert schlicht nichts und es bleibt beim alten Verhalten.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  if (window.__glGalleryFix) return;
  window.__glGalleryFix = true;

  var TOLERANZ = 8;
  var startX = 0;
  var startY = 0;
  var startSlide = null;

  function findeSlide(ziel) {
    if (!ziel || !ziel.closest) return null;
    return ziel.closest('xo-carousel-thumbnail xo-carousel-slide');
  }

  function schalte(slide) {
    var liste = slide.parentElement;
    if (!liste) return;

    var index = Array.prototype.indexOf.call(liste.children, slide);
    if (index < 0) return;

    var karussell = slide.closest('xo-carousel');
    if (!karussell) return;

    var name = karussell.xoName;
    if (!name) return;

    if (!window.xoCarousel || typeof window.xoCarousel.goTo !== 'function') return;

    try {
      window.xoCarousel.goTo(name, index);
    } catch (e) {
      /* still bleiben, lieber nichts tun als etwas kaputt machen */
    }
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      startSlide = findeSlide(e.target);
      startX = e.clientX;
      startY = e.clientY;
    },
    true
  );

  document.addEventListener(
    'pointerup',
    function (e) {
      var slide = findeSlide(e.target);
      if (!slide || slide !== startSlide) return;

      if (
        Math.abs(e.clientX - startX) > TOLERANZ ||
        Math.abs(e.clientY - startY) > TOLERANZ
      ) {
        return;
      }

      schalte(slide);
    },
    true
  );

  /* Tastatur: die Folien tragen tabindex 0, also soll auch
     Eingabetaste und Leertaste das Bild wechseln. */
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var slide = findeSlide(e.target);
      if (!slide) return;
      e.preventDefault();
      schalte(slide);
    },
    true
  );
})();
